import React, { Component, PropTypes } from 'react';
import Slider from 'react-slick';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import classNames from 'classnames';

import 'slick-carousel/slick/slick.css';

import { byIdShape } from 'utils/propTypes';

import Upload from './Upload';

import styles from './styles.scss'; // eslint-disable-line no-unused-vars


class Images extends Component {

  static propTypes = {
    canUpload: PropTypes.bool,
    charger: PropTypes.shape({ images: PropTypes.array }).isRequired,
    className: PropTypes.string,
    imagesById: byIdShape.isRequired,
    onNewImageSuccess: PropTypes.func.isRequired,
    usersById: byIdShape.isRequired,
  };

  static defaultProps = {
    canUpload: false,
    className: null,
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      showUpload: false,
    };
  }

  render() {
    const { charger, className, imagesById, usersById, onNewImageSuccess, canUpload } = this.props;
    const enableSlider = charger.images && charger.images.length > 1;
    return (
      <div
        className={classNames('charger-images', {
          'single-image': charger.images && charger.images.length === 1,
          'can-upload': canUpload,
        }, className)}
        styleName='styles.charger-images'
      >
        { charger.images && imagesById && charger.images.length > 0 ?
          <div styleName='styles.images'>
            <Slider
              lazyLoad
              infinite={enableSlider}
              adaptiveHeight={false}
              mobileFirst
              arrows={enableSlider}
            >
              { charger.images.map((pk) => {
                const image = imagesById[pk];
                const user = usersById[image.uploaded_by];
                let orientation = 'landscape';
                if (image.slider.width < image.slider.height) orientation = 'portrait';
                else if (image.slider.width === image.slider.height) orientation = 'square';
                return (
                  <div className={orientation} key={pk}>
                    <img
                      alt={image.name}
                      src={image.slider.url}
                      srcSet={[
                        `${image.slider.url} ${image.slider.width}w`,
                        `${image.slider.url2x} ${image.slider.width * 2}w`,
                      ].join(', ')}
                      sizes={[
                        '(min-width: 1200px) 555px',
                        '(min-width: 992px) 455px',
                        '(min-width: 768px) 345px',
                        'calc(100vw - 30px)',
                      ].join(', ')}
                    />
                    <div styleName='styles.caption'>
                      <FormattedMessage
                        id='charger.image.byline'
                        values={{
                          uploadedBy: (
                            <Link to={`/user/${user.username}/`}>{ user.public_name }</Link>
                          ),
                          uploadedOn: new Date(image.uploaded_on),
                        }}
                        defaultMessage='Uploaded by {uploadedBy} on {uploadedOn, date, long}'
                      />
                    </div>
                  </div>
                );
              }) }
            </Slider>
          </div>
        : null }

        { canUpload ?
          <button
            type='button'
            className='btn btn-secondary show-upload-images'
            styleName='styles.show-upload-images'
            onClick={() => this.setState({ showUpload: !this.state.showUpload })}
          >
            { charger.images && charger.images.length > 0 ? 'Upload More Images' : 'Upload Images'}
          </button>
        : null }
        { canUpload ?
          <Upload
            charger={charger}
            display={this.state.showUpload}
            handleClose={() => this.setState({ showUpload: false })}
            onNewImageSuccess={onNewImageSuccess}
          />
        : null }

      </div>
    );
  }
}

export default Images;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Charger/components/Images/index.jsx